import { Component, input, ViewEncapsulation } from '@angular/core';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';

import { UiPalette } from '@eiq/ui';

@Component({
  selector: 'empathy-icon-tooltip',
  templateUrl: 'icon-tooltip.component.html',
  styleUrls: ['./icon-tooltip.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class IconTooltipComponent {
  icon = input<IconDefinition>();
  color = input<UiPalette>();
  tooltip = input<string>();
}
